import React, { useState } from 'react';
import PropTypes from 'prop-types';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import PerformRealmCommunity from './RealmCommunity';
import { DivisionIcon } from 'global/components/PerformIcons';
import { map } from 'global/lib/lodash';

export default function PerformRealmDivision({ realm= {},
    currentDivision = '0',
    changeDivision = () => {}, ...props }) {
  const [active, setActive] = useState(false);
  const division = realm;

  const toggleActive = () => {
    setActive(!active);
  };

  return (
    <>
      <ListItemButton onClick={() => toggleActive()} style={{ marginLeft: 32 }}>
        <ListItemIcon>
          <DivisionIcon />
        </ListItemIcon>
        <ListItemText primary={division.name} />
      </ListItemButton>
      {active ? (
        <List>
          {map(division.realms, (item) => {
            return <PerformRealmCommunity key={item.id} realm={item} />;
          })}
        </List>
      ) : (
        <></>
      )}
    </>
  );
}

PerformRealmDivision.propTypes = {
  realm: PropTypes.object,
  currentDivision: PropTypes.string,
  changeDivision: PropTypes.func,
};
